enum OrderStatus {
    Pending = 0,      // Ön ödeme alındı
    Confirmed = 1,    // Kampanya tamamlandı
    Cancelled = 2,    // İptal edildi (para iadesi yapılır)
    Abandoned = 3     // Kullanıcı vazgeçti (kesinti uygulanır)
};
export default OrderStatus;